import { useMemo } from 'react';
import { type BaseValidationError, type PrimitiveFieldInstance, useField } from '@adv-frontend/form-kit';
import { useFormFieldErrorProps } from './useFormFieldErrorProps';

/*
 * Хук для получения пропсов для компонентов DatePicker и FormField
 */
export function useDateFieldProps<FieldValidationError extends BaseValidationError, FieldContext = unknown>(
    instance: PrimitiveFieldInstance<string, FieldValidationError, FieldContext>,
    getErrorMessage: (error: FieldValidationError) => string
) {
    const field = useField(instance);
    const formFieldErrorProps = useFormFieldErrorProps(field.state, getErrorMessage);

    const fieldProps = useMemo(() => {
        const props = field.getProps();

        if (typeof props.value !== 'string') {
            throw new Error('Value must be a string');
        }

        return {
            ...props,
            value: props.value ? new Date(props.value) : null,
            onChange: (value: Date | null) => props.onChange(value?.toISOString() || ''),
        };
    }, [field]);

    const scrollProps = useMemo(() => field.getScrollProps(), [field]);

    return { field, formFieldErrorProps, fieldProps, scrollProps };
}
